<template>
    <div style="position: relative !important;">
        <div class="az-form-content">
            <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
                <div class="card-dados__titulo resultado-card mb-0">
                    <h3 id="tituloPainel">Resultado</h3>
                </div>
                <div v-if="resultados.length > 1" class="acao-expandir-recolher">
                    <v-spacer></v-spacer>
                    <div class="text-xs-right">
                        <v-btn v-if="ultimoEstadoPaineis === 'recolhido'" flat @click="expandirTodos" class="botao-simples mr-3">
                            <v-icon left size="15">fas fa-chevron-down</v-icon>
                            Expandir Todos
                        </v-btn>

                        <v-btn v-else flat @click="recolherTodos" class="botao-simples mr-3">
                            <v-icon left size="15">fas fa-chevron-up</v-icon>
                            Recolher Todos
                        </v-btn>
                    </div>
                </div>
                <p v-else-if="resultados.length < 1"  class="mensagem-quando-vazio">
                    Não há resultado para itens/lotes desta compra.
                </p>
                <v-expansion-panel v-model="paineis"
                                   expand
                                   class="painel-itens"
                                   :class="{ 'mt-3': resultados.length < 2}">
                    <v-expansion-panel-content v-for="resultado in resultados"
                                               :key="`${resultado.tipo}-${resultado.id}-expansion-panel-content`"
                                               :class="`expansion-panel-content-expansion-panel-content`"
                                               class="painel-itens__linha borda-linha cabecalho-painel">
                      <template v-slot:header>
                            <div class="alinhar-info" style="text-transform: none !important">
                                {{ resultado.sequencial }} - {{ resultado.descricao | azClipText(100) }}
                            </div>

                        <v-spacer></v-spacer>
                        <botao-visualizar-propostas texto="Visualizar Propostas"
                                                    :deshabilitado="false" class="mr-2"
                                                    color-class="primary-color"
                                                    style="justify-content: end; display: flex; align-items: center;"
                                                    mensagem-tooltip="Clique para baixar todas as propostas do item/lote"
                                                    @eventoVisualizarPropostas="eventoVisualizarProposta(resultado.id, resultado.tipo)"/>
                        </template>

                        <v-data-table :headers="colunasTabela" :items="resultado.fornecedores" hide-actions
                                      class="az-table-list tabela-ranking"
                                      no-data-text="Não houveram vencedores para este item.">

                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td align="center">
                                        <div class="circulo">
                                            <span v-if="props.item.classificacao">{{ props.item.classificacao }}°</span>
                                            <span v-else>?&nbsp;</span>
                                        </div>
                                    </td>
                                    <td align="left">
                                        {{ props.item.cpfCnpj | cpfCnpjFormatter }} - {{ props.item.razaoSocial }}<br/>
                                    </td>
                                    <td align="center">
                                        {{ props.item.situacao || '--' }}<br/>
                                    </td>
                                    <td align="center">
                                        <span>{{ props.item.quantidadeTotalItem | cdCurrency('', 2)}}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ props.item.valorUnitario | cdCurrency("R$", 2)}}</span>
                                    </td>
                                    <td align="center">
                                        {{  props.item.valorTotal | cdCurrency("R$", 2) }}
                                    </td>

                                    <td align="center">
                                        {{ props.item.percentualDesconto | cdCurrency('', 2) }}
                                    </td>
                                    <td align="center">
                                        {{ props.item.numeroAutorizacao || '--' }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-flex>
        </div>
    </div>
</template>

<script>

import {actionTypes} from '@/core/constants'
import cpfCnpjFormatter from '../../../../filters/cpfCnpjFormatter'
import BotaoVisualizarPropostas from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/BotaoVisualizarPropostas.vue'

export default {
    name: 'CompraDiretaLegadaDetalhesResultado',
    components: {BotaoVisualizarPropostas},
    data() {
        return {
            paineis: [],
            ultimoEstadoPaineis: 'recolhido',
            totalmenteRecolhido: true,
            totalmenteExpandido: false,
            colunasTabela: [
                {text: 'Classificação', value: 'classificacao', align: 'center', sortable: false, class: 'primary--text'},
                {text: 'Fornecedor', value: 'razaoSocial', align: 'left', sortable: false, class: 'primary--text'},
                {text: 'Status', value: 'situacao', align: 'center', sortable: false, class: 'primary--text'},
                {text: 'Quantidade', value: 'quantidadeTotalItem', align: 'center', sortable: false, class: 'primary--text'},
                {text: 'Valor Unitário', value: 'valorUnitario', align: 'center', sortable: false, class: 'primary--text'},
                {text: 'Valor Total', value: 'valorTotal', align: 'center', sortable: false, class: 'primary--text'},
                {text: 'Desconto (%)', value: 'percentualDesconto', align: 'center', sortable: false, class: 'primary--text'},
                {text: 'Autorização', value: 'numeroAutorizacao', align: 'center', sortable: false, class: 'primary--text'}
            ],
            resultados: [],
            processoAquisicaoId: null,
            execucaoId: null,
        }
    },
    created() {
        this.setIds()
        this.buscarResultadoExecucao()
    },
    mounted() {
    },
    methods: {
        cpfCnpjFormatter,
        setIds() {
            this.processoAquisicaoId = this.$route.params.id
            this.execucaoId = this.$route.params.execucaoId
        },
        async buscarResultadoExecucao() {
            if(!this.processoAquisicaoId || !this.execucaoId)
                this.mostrarNotificacaoErro('Identificador do processo de aquisição ou da execução não encontrado.')

            const data = {processoAquisicaoId: this.processoAquisicaoId, execucaoId: this.execucaoId}

            const resultado = await this.$store.dispatch(actionTypes.LEGADO.BUSCAR_RESULTADO_EXECUCAO, data)

            this.resultados = [ ...resultado.itemLoteResultados ]
        },
        expandirTodos() {
            this.paineis = this.resultados.map(() => {
                return true
            })
            this.totalmenteExpandido = true
            this.verificarUltimoEstado()
        },
        verificarUltimoEstado() {
            if (this.totalmenteExpandido) {
                this.ultimoEstadoPaineis = 'expandido'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoPaineis = 'recolhido'
            }
        },
        recolherTodos() {
            this.paineis = this.resultados.map(() => {
                return false
            })
            this.totalmenteExpandido = false
        },
        async eventoVisualizarProposta(id, tipo){
            const dados = {
                processoAquisicaoId: this.processoAquisicaoId,
                execucaoId: this.execucaoId,
                id: id,
                tipo: tipo
            }
            await this.$store.dispatch(actionTypes.LEGADO.BAIXAR_RELATORIO_PROPOSTAS_ITEM_LOTE_LEGADO, dados)
        }
    }
}
</script>

<style scoped lang="stylus">

</style>